/**
 * World-boss state — surfaced to the HUD/minimap. Server emits
 * `world-boss-event` (kind: 'spawn' | 'killed') broadcast messages,
 * the realm client funnels them in here.
 */

import { create } from 'zustand';

interface WorldBossEvent {
  kind: 'spawn' | 'killed';
  bossId: string;
  name: string;
  pos?: { x: number; z: number };
  zone?: string;
  topDamageBy?: string;
  participants?: number;
  totalDamage?: number;
  nextRespawnAt?: number;
  ts: number;
}

interface WorldBossStore {
  /** Last announcement event — used for the toast. Cleared after a few sec. */
  lastEvent: WorldBossEvent | null;
  /** Currently-alive world boss id (empty if none in the world). */
  activeBossId: string;
  /** Spawn position for minimap marker. */
  activePos: { x: number; z: number } | null;
  /** Server-ms when the next respawn happens (after a kill). */
  nextRespawnAt: number;
  pushEvent: (e: WorldBossEvent) => void;
  clearLast: () => void;
}

export const useWorldBoss = create<WorldBossStore>((set) => ({
  lastEvent: null,
  activeBossId: '',
  activePos: null,
  nextRespawnAt: 0,
  pushEvent: (e) => {
    if (e.kind === 'spawn') {
      set({
        lastEvent: e,
        activeBossId: e.bossId,
        activePos: e.pos ?? null,
        nextRespawnAt: 0,
      });
    } else {
      set({
        lastEvent: e,
        activeBossId: '',
        activePos: null,
        nextRespawnAt: e.nextRespawnAt ?? 0,
      });
    }
  },
  clearLast: () => set({ lastEvent: null }),
}));
